var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"meter-device-search mt-5"},[(_vm.organization && _vm.canSeeCommissionings)?_c('organization-commissionings',{attrs:{"organization-id":_vm.organization.id,"kind":"meter-device"}}):_vm._e(),(_vm.organization)?_c('meter-device-list',{attrs:{"organization-id":_vm.organization.id}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }